import { Navigate, useLocation } from 'react-router-dom'
import { resolveLegacyRoute } from './legacyRoutes'

/**
 * The client half of the no-broken-URLs contract (R1, roadmap §4).
 *
 * The server half is already in place: the SPA fallback in `Program.cs` serves this
 * bundle for any non-`/api`, non-static GET, so `/UserDetailsAdmin?username=x` reaches
 * the browser instead of 404ing. This turns it into `/users/x`.
 *
 * It sits ABOVE `<Routes>` on purpose. Below it, the catch-all `*` route would match a
 * legacy URL first and send the user to the login page — a broken bookmark that looks
 * like a session problem.
 *
 * `replace` matters: the legacy URL must not stay in the history, or Back from the
 * React screen lands on it and redirects forward again, trapping the user.
 */
export default function LegacyRedirects({ children }) {
  const { pathname, search, hash } = useLocation()
  const target = resolveLegacyRoute(pathname, search, hash)

  return target ? <Navigate to={target} replace /> : children
}
